import React, { Component } from 'react'

import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import LockIcon from '@material-ui/icons/Lock'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip'
import HamburgerMenu from '@material-ui/icons/Menu';

import ReactGA from 'react-ga';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Hoc from '../../../hoc/hoc';
import * as actions from '../../../store/actions/index';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classes from './Toolbar.css'


const mLinks = {
	'one':'Kako se učestvuje?',
	'two':'Durex ispit',
	'tree':'Nagrade',
	'four':'Dobitnici',
	'five':'Kontakt',
	'six':'Moj nalog'
}


class toolbar extends Component {

	state = {
		anchorEl: null
	}

	doClick = (nm) => {
		if (nm === "profile") {
			//console.log(this.props);
			this.props.history.push('/profil');
			this.props.onUpdatePath('/profil');
			this.props.onUpdateLPElement('zero');
			this.props.onUpdateLPPosition(0);
		} else if (nm==="quiz") {
			this.props.history.push('/kviz');
			this.props.onUpdatePath('/kviz');
			this.props.onUpdateLPElement('zero');
			this.props.onUpdateLPPosition(0);
		} else {
			if (this.props.curPath!=='/') {
				this.props.history.push('/');
				this.props.onUpdatePath('/');
			}
			this.props.onUpdateLPElement(nm);



			ReactGA.event({
				category: 'Navigation',
				action: 'Clicked menu link:' + mLinks[nm],
			});
		}
	}

	// local state user menu
	handleUserMenuOpen = event => {
		this.setState({anchorEl: event.currentTarget});
	}

	handleUserMenuClose = () => {
		this.setState({anchorEl: null});
	}

	render () {
		const { anchorEl } = this.state;

		let ico;
		/*
		if (!this.props.hamburger) {
			ico = <LeftArrow />;
		} else {
			*/
			ico = <HamburgerMenu />;
		//}

		let profileIcon;
		let profileMenu;

		if (this.props.isAuthenticated) {
			if (this.props.avatar) {
				profileIcon = <img src={this.props.avatar} className={classes.avatarImage} alt=""/>
			} else {
				profileIcon = <AccountCircle />;
			}
			
			profileMenu = (
				<Menu
					id="user-menu"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={this.handleUserMenuClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right'
					}}
					getContentAnchorEl={null}
				>
					<MenuItem onClick={() => {
						//this.props.onUpdateModal(true,'profile');
						this.doClick('profile');
						this.handleUserMenuClose();
						}}>
						Moj nalog
					</MenuItem>
					<MenuItem onClick={() => {
						this.props.onLogout();
						this.handleUserMenuClose();
						}}>
						Odjava
					</MenuItem>
				</Menu>
			)
		} else {
			profileIcon = <LockIcon />;
			profileMenu = null;
		}

		return (
			<Hoc>
			<AppBar position='static' style={{ backgroundColor:'#013870' }} id="staticAppBar">
			  <Toolbar disableGutters >
				<div className={classes.onlyMobile}>
					<IconButton
						className={classes.openMenuButton}
						variant="fab" 
						aria-label="More"

						aria-haspopup="true"
						onClick={() => this.props.onUpdateSideDrawer(true)}
					>
						{ico}
					</IconButton>
				</div>

				<div className={classes.menuHolder + ' ' + classes.onlyDesktop + ' ' + classes.menuHolderLeft} >
				  <Button className={classes.menubutton} tabIndex="1"
						onClick={ () => { this.doClick('one') } }
					>{this.props.menuLinks[0]}</Button>
				  <Button 
					  //className={this.props.curPath==="/kviz" ? classes.menuButtonHighlighted : classes.menubutton}
					  className={classes.menubutton}
					  tabIndex="2"
						onClick={ () => { /*this.doClick('quiz')*/this.doClick('two') } }>
						{this.props.menuLinks[1]}
						</Button>
				  <Button className={classes.menubutton} tabIndex="3"
						onClick={ () => { this.doClick('three') } }
					>
					{this.props.menuLinks[2]}
					</Button>
				</div>
				<div className={classes.menuHolder + ' ' + classes.onlyDesktop}
				>
				  <img
					src='./durex-logo-header-large.png'
					alt='Durex Love Sex'
					className={classes.logo}
				  />
				</div>
				<div className={classes.menuHolder + ' ' + classes.onlyDesktop + ' ' + classes.menuHolderRight} >
					<Button className={classes.menubutton} tabIndex="4"
						onClick={ () => { this.doClick('four') } }
					>
						{this.props.menuLinks[3]}
					</Button>
					<Button className={classes.menubutton} tabIndex="5"
						onClick={ () => { this.doClick('five') } }
					>
						{this.props.menuLinks[4]}
					</Button>
					<Button 
						className={this.props.curPath==="/profil" ? classes.menuButtonHighlighted : classes.menubutton}
						tabIndex="6"
						onClick={ () =>
							{
								if (this.props.isAuthenticated) {
									//this.props.onUpdateModal(true,'profile');
									this.doClick('profile');
								} else {
									this.props.onUpdateModal(true,'login');
								}
							} 
						}
					>
					{this.props.isAuthenticated ? this.props.menuLinks[5] : 'Prijava' }
					</Button>
				</div>
						<Hoc>
							<Tooltip id="tooltip-icon2" 
								title={this.props.isAuthenticated ? "Moj nalog" : "Login"}
								placement="left"
							>
								<IconButton
									aria-owns={anchorEl ? 'user-menu' : null}
									aria-haspopup="true"
									className={classes.loginButton}
									name={this.props.isAuthenticated ? "profile" : "signin"}
									aria-label={this.props.isAuthenticated ? 'Moj nalog' : 'Prijava'}
									color='inherit'
									rel='noopener'
									onClick={(e) =>
										{
											if (this.props.isAuthenticated) {
												this.handleUserMenuOpen(e);
											} else {
												this.props.onUpdateModal(true,'login');
											}
										}
									}
								>
									{profileIcon}
								</IconButton>
							</Tooltip>
							{profileMenu}
						</Hoc>
			  </Toolbar>
			</AppBar>


			{/* second appbar */}

			<AppBar 
				position='fixed' 
				style={{ backgroundColor:'#013870' }}
				id="fixedAppBar"
				className = { this.props.lpPosition===0 ? classes.appbar + ' ' + classes.unfixed  : classes.appbar + ' ' + classes.fixme }
			>
			  <Toolbar disableGutters >

				<div className={classes.onlyMobile}>
					<IconButton
						className={classes.openMenuButton}
						variant="fab" 
						aria-label="More"

						aria-haspopup="true"
						onClick={() => this.props.onUpdateSideDrawer(true)}
					>
						{ico}
					</IconButton>
				</div>

				<div className={classes.menuHolder + ' ' + classes.onlyDesktop + ' ' + classes.menuHolderLeft} >
					<Button 
						className={this.props.lpPosition===1 ? classes.menuButtonHighlighted : classes.menubutton}
						onClick={ () => { this.doClick('one') } }
					>
					{this.props.menuLinks[0]}
					</Button>
					<Button 
						//className={this.props.curPath==="/kviz" ? classes.menuButtonHighlighted : classes.menubutton}
						className={this.props.lpPosition===2 ? classes.menuButtonHighlighted : classes.menubutton}
						//onClick={ () => { this.doClick('quiz')/*this.doClick('two')*/ } }>
						onClick={ () => { this.doClick('two') } }>
						{this.props.menuLinks[1]}
						</Button>
					<Button 
						className={this.props.lpPosition===3 ? classes.menuButtonHighlighted : classes.menubutton}
						onClick={ () => { this.doClick('three') } }
					>
					{this.props.menuLinks[2]}
					</Button>
				</div>
				<div className={classes.menuHolder + ' ' + classes.onlyDesktop} >
				  <img
					src='./durex-logo-header-large.png'
					alt='Durex Love Sex'
					className={classes.logo}
				  />
				</div>
				<div className={classes.menuHolder + ' ' + classes.onlyDesktop + ' ' + classes.menuHolderRight} >
					<Button 
						className={this.props.lpPosition===4 ? classes.menuButtonHighlighted : classes.menubutton}
						onClick={ () => { this.doClick('four') } }
					>
					{this.props.menuLinks[3]}
					</Button>
					<Button 
						className={this.props.lpPosition===5 ? classes.menuButtonHighlighted : classes.menubutton}
						onClick={ () => { this.doClick('five') } }
					>
					{this.props.menuLinks[4]}
					</Button>
					<Button 
						className={this.props.curPath==="/profil" ? classes.menuButtonHighlighted : classes.menubutton}
						onClick={ () =>
							{
								if (this.props.isAuthenticated) {
									//this.props.onUpdateModal(true,'profile');
									this.doClick('profile');
								} else {
									this.props.onUpdateModal(true,'login');
								}
							} 
						}
					>
						{this.props.isAuthenticated ? this.props.menuLinks[5] : 'Prijava' }
					</Button>
				</div>
						<Hoc>
							<Tooltip id="tooltip-icon3" 
								title={this.props.isAuthenticated ? "Moj nalog" : "Login"}
								placement="left"
							>
								<IconButton
									aria-owns={anchorEl ? 'user-menu' : null}
									aria-haspopup="true"
									className={classes.loginButton}
									name={this.props.isAuthenticated ? "profile" : "signin"}
									aria-label={this.props.isAuthenticated ? 'Moj nalog' : 'Prijava'}
									color='inherit'
									rel='noopener'
									onClick={(e) =>
										{
											if (this.props.isAuthenticated) {
												this.handleUserMenuOpen(e);
											} else {
												this.props.onUpdateModal(true,'login');
											}
										}
									}
								>
									{profileIcon}
								</IconButton>
							</Tooltip>
							{profileMenu}
						</Hoc>
			  </Toolbar>
			</AppBar>
		</Hoc>
		)
	}
}

const mapStateToProps = state => {
	return {
		isAuthenticated: state.auth.token !== null,
		lpPosition: state.my.landingPagePosition,
		curPath: state.my.currentPath,
		avatar: state.auth.avatarData,
	}
}

const mapDispatchToProps = dispatch => {
	return {
		onUpdateSideDrawer: (sideState) => dispatch ( actions.changeSidedrawer(sideState) ),
		onUpdateModal: (modState, modWhat) => dispatch( actions.changeModal(modState, modWhat) ),
		onUpdateLPElement: (lpel) => dispatch ( actions.changeLandingPageElement(lpel) ),
		onUpdateLPPosition: (lpPos) => dispatch ( actions.changeLandingPagePosition(lpPos) ),
		onLogout: () => dispatch (actions.logout() ),
		onUpdatePath: (newpath) => dispatch (actions.changePath(newpath)),
	}
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(toolbar));


// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js